;(function() {
  const bbGirlsPicks = document.querySelectorAll('.bb-girls-picks')
  bbGirlsPicks.forEach(this_ => {
    const commentList = this_.querySelector('.bb-girls-picks-comment-list')
    const commentSwiperScrollbar = this_.querySelector('.swiper-scrollbar')

    init()
    window.addEventListener('resize', init)

    function init() {
      if(window.innerWidth > 960) {
        new Swiper(commentList, {
          slidesPerView: 4,
          grid: {
              fill: 'row',
              rows: 1,
          },
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
        })
      } else {
        new Swiper(commentList, {
          slidesPerView: 2.3,
          grid: {
              fill: 'row',
              rows: 1,
          },
          scrollbar: {
              el: commentSwiperScrollbar,
          },
        })
      }
    }
  })
})()